export default __webpack_public_path__ + "static/media/benefit1.aafb4178.svg";